var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.addSymbol('a')}}},[_vm._v("Add A")]),_vm._v(" "+_vm._s(_vm.str)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }